module.exports = __webpack_public_path__ + "static/img/wxHoverTop.07aa68e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/footer/wxHoverTop.png
// module id = oCMN
// module chunks = 12